import { Fragment, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import Laoding from "../../../../components/Loading";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import PrintLabelButton from "../../../../components/Shipment/Label/PrintLabelButton";
import dateTimeToJalali from "../../../../function/jalali/dateTimetoJalali";
import PayLinkAgentOrderCopyButton from "./PayLinkAgentOrderCopyButton";
import PayLinkAgentOrdersDeleteButton from "./PayLinkAgentOrdersDeleteButton";
import PayLinkAgentOrdersPayButton from "./PayLinkAgentOrdersPayButton";

export default function PayLinkAgentOrdersTable({
  data,
  isFetching,
  filters,
  refetch,
}) {
  const [disableButtons, setDisableButtons] = useState(false);

  return (
    <div className="py-5">
      <p className="text-success fs-5 mb-0">
        <strong>تعداد: </strong>
        <strong>{data.count.toLocaleString()}</strong>
      </p>

      <div className="w-100 overflow-x-auto">
        <Table striped bordered className="table-center">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره سفارش</th>
              <th>تاریخ ثبت</th>
              <th>وضعیت</th>
              <th style={{ minWidth: 90 }}>
                <span>مبلغ</span>
                <span className="fs-very-small"> (ریال)</span>
              </th>
              <th>نام فرستنده</th>
              <th>موبایل فرستنده</th>
              <th>شهر فرستنده</th>
              <th>نام گیرنده</th>
              <th>موبایل گیرنده</th>
              <th>شهر گیرنده</th>
              <th>عملیات</th>
            </tr>
          </thead>

          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="100">
                  <Laoding />
                </td>
              </tr>
            )}

            {!isFetching &&
              data.items.map((item, idx) => (
                <tr key={item.id}>
                  <td>
                    {idx + 1 + (filters.get("page") - 1) * filters.get("items")}
                  </td>
                  <td>{item.numberParcel}</td>
                  <td>{dateTimeToJalali(item.created_at).full}</td>
                  <td>
                    <Badge
                      className={
                        item.factorstatus === "close"
                          ? "bg-success"
                          : "bg-danger"
                      }
                    >
                      {item.factorstatus === "close"
                        ? "پرداخت شده"
                        : "در انتظار پرداخت"}
                    </Badge>
                  </td>

                  <td>
                    {(item.realPayable + item.amountCOD).toLocaleString()}
                  </td>

                  <td>
                    {item.source.type === 0 && (
                      <span>
                        {item.source.name} {item.source.family}
                      </span>
                    )}
                    {item.source.type === 1 && (
                      <span>{item.source.compony}</span>
                    )}
                  </td>

                  <td>{item.source.phone}</td>
                  <td>
                    {item.source.province.faName} -
                    <strong> {item.source.city.faName}</strong>
                  </td>

                  <td>
                    {item.destination.type === 0 && (
                      <span>
                        {item.destination.name} {item.destination.family}
                      </span>
                    )}
                    {item.destination.type === 1 && (
                      <span>{item.destination.compony}</span>
                    )}
                  </td>

                  <td>{item.destination.phone}</td>
                  <td>
                    {item.destination.province.faName} -
                    <strong> {item.destination.city.faName}</strong>
                  </td>

                  <td style={{ minWidth: 180 }} className="p-2">
                    <div className="d-flex flex-wrap align-items-center justify-content-center gap-2">
                      {item.factorstatus === "close" && (
                        <Fragment>
                          <PrintLink byNumberParcel ids={[item.numberParcel]}>
                            پرینت فاکتور
                          </PrintLink>

                          <PrintLabelButton
                            className="btn btn-outline-orange"
                            numberParcels={[item.numberParcel]}
                          />
                        </Fragment>
                      )}

                      {item.factorstatus !== "close" && (
                        <Fragment>
                          <PayLinkAgentOrdersPayButton
                            item={item}
                            onPending={() => setDisableButtons(true)}
                            onSubmit={() => {
                              setDisableButtons(false);
                              refetch();
                            }}
                            disabled={disableButtons}
                          />

                          <PayLinkAgentOrdersDeleteButton
                            onPending={() => setDisableButtons(true)}
                            disabled={disableButtons}
                            item={item}
                            onSubmit={() => {
                              setDisableButtons(false);
                              refetch();
                            }}
                          />
                          <PayLinkAgentOrderCopyButton item={item} />
                        </Fragment>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
